import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
  ElementRef
} from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { IOffersRetailerListItem } from "src/app/models";
import { Location } from "@angular/common";
import {
  ReceivingOfferStatus,
  RetailerOffersViewType,
  asObject,
  HttpMethod,
  OfferKind,
  UserAction,
  LxmAppModule,
  OfferRequestStatus,
  SupplierOfferStatus
} from "src/app/enum";
import {
  DataTableService,
  SignalRService,
  OfferService,
  AuthenticationService
} from "src/app/_services";
import { forkJoin, Subscription } from "rxjs";
import { HubConnection } from "@microsoft/signalr";
import { ActivatedRoute } from "@angular/router";
import { MatSort } from "@angular/material/sort";
import { AppState } from "src/app/state/app.state";
import { map, mergeMap } from "rxjs/operators";
import { LxmDialog } from "src/app/_helpers";
import { OfferExportDialogComponent } from "../offer/dialogs/export/export-offer.dialog";
import { OfferImportDialogComponent } from "../offer/dialogs/import/import-offer.dialog";
import { OffersListBase } from "./offers-list-base";
import { OffersListState, OffersListViewType } from "./offers-list.state";

@Component({
  selector: "offers-list-card",
  templateUrl: "./offers-list.card.html",
  host: { class: "data-table-card" },
  styleUrls: ["./offers-list.card.scss", "./offers-list-base.scss"]
})
export class OffersListCardComponent
  extends OffersListBase<IOffersRetailerListItem, any, OffersListState>
  implements OnInit, OnDestroy {
  private _hubConnection: HubConnection;
  private _signalRSubscription: Subscription;

  public LxmAppModule = LxmAppModule;
  public UserAction = UserAction;
  public OfferKind = OfferKind;

  public dataUrl = "offers/forRetailer";
  method = HttpMethod.Post;
  initialData;
  public translationsPath = "cards.offers";

  @ViewChild("download") private _download: ElementRef;

  public controls = new FormGroup({
    listViewType: new FormControl(this.state.listViewType)
  });

  public ReceivingOfferStatus = ReceivingOfferStatus;

  public receivingOffersListViewTypeOptions = [
    {
      id: OffersListViewType.All,
      label: "cards.offers.filters.all"
    },
    {
      id: OffersListViewType.Active,
      label: "cards.offers.filters.active"
    },
    {
      id: OffersListViewType.Archive,
      label: "cards.offers.filters.archive"
    }
  ];

  public requestedOffersListViewTypeOptions = [
    {
      id: OffersListViewType.All,
      label: "cards.offers.filters.all"
    },
    {
      id: OffersListViewType.RequestDrafts,
      label: "cards.offers.filters.drafts"
    },
    {
      id: OffersListViewType.SentRequests,
      label: "cards.offers.filters.sent"
    }
  ];

  public sentOffersListViewTypeOptions = [
    {
      id: OffersListViewType.All,
      label: "cards.offers.filters.all"
    },
    {
      id: OffersListViewType.Saved,
      label: "cards.offers.filters.saved"
    },
    {
      id: OffersListViewType.Active,
      label: "cards.offers.filters.active"
    },
    {
      id: OffersListViewType.Archive,
      label: "cards.offers.filters.archive"
    }
  ];

  public reqTableColumns = [
    "name",
    "suppliers",
    "productCount",
    "to",
    "status"
  ];
  public recevingOffersTableColumns = [
    "offer_select",
    // "supplier_image",
    "supplier",
    "name",
    "to",
    "approved",
    // "assignedTo",
    "status"
  ];
  public sendingOffersTableColumns = [
    // "retailer_image",
    "retailer",
    "name",
    "sentAt",
    "period",
    "approved",
    "status"
  ];

  public table = {
    columns: this.recevingOffersTableColumns
  };

  protected colPropertyMap = {
    'approved': 'confirmedProductCount',
    'period': 'from',
    'suppliers': 'suppliers/$count'
  };

  public canManageSupplierOffers = false;

  constructor(
    public appState: AppState,
    private _offerService: OfferService,
    route: ActivatedRoute,
    private _dialog: LxmDialog,
    dataTableService: DataTableService<IOffersRetailerListItem, any>,
    cd: ChangeDetectorRef,
    location: Location,
    public state: OffersListState,
    private _authService: AuthenticationService,
    private _signalR: SignalRService
  ) {
    super(location, dataTableService, cd);
    this._state = state;

    this.canManageSupplierOffers = this._authService.hasRights([
      UserAction.ManageSupplierOffers
    ]);

    this.initialData = route?.snapshot?.data?.initialData;
    this.kind = route?.snapshot?.data?.offerKind;
    this.state.initializeListViewType(this.kind);

    if (this.kind == OfferKind.ReceivingOffer) {
      this.table.columns = this.recevingOffersTableColumns;
      this.dataUrl = "offers/forRetailer";
      this.searchUrl = "/offers/receiving/search";
    } else if (this.kind == OfferKind.SupplierOffer) {
      this.table.columns = this.sendingOffersTableColumns;
      this.dataUrl = "offers/forSupplier";
      this.searchUrl = "/offers/sending/search";
    } else if (this.kind == OfferKind.OfferRequest) {
      this.table.columns = this.reqTableColumns;
      this.dataUrl = "offers/requestedOffers";
      this.searchUrl = "/offers/requests/search";
    }

    this._signalRSubscription = this._signalR.commonHub.subscribe((x) => {
      this._hubConnection = x;
      if (!x) {
        return;
      }
      x.on("offerHasChanged", (data) => {
        const row = this.dataSource.data.find((r) => r.id === data.offerId);
        if (row) {
          row.isNew = data.read === false;
        }
      });
    });

    // this.dataSource.loading$.subscribe((val: boolean) => {
    //   this._state.isSearchLoading = val;
    // });
  }


  public getReceivingOfferStatusProgress(status: ReceivingOfferStatus) {
    return this._offerService.getReceivingOfferStatusProgress(status);
  }

  public getOfferRequestStatusProgress(status: OfferRequestStatus) {
    return this._offerService.getOfferRequestStatusProgress(status);
  }

  public getSendingOfferStatusProgress(status: SupplierOfferStatus) {
    return this._offerService.getSendingOfferStatusProgress(status);
  }

  public setListView(toSet: OffersListViewType) {
    super.setListView(toSet);
    this.controls.get('listViewType')?.setValue(toSet, { emitEvent: false });
  }

  public openImportDialog() {
    this._dialog.open(
      OfferImportDialogComponent,
      {
        resolve: () => {
          const resolvers: any = {
            formData: this._offerService.getOfferImportFormData()
          };

          return forkJoin(resolvers);
        }
      },
      (res) => {
        if (!res) {
          return;
        }

        this.load();
      }
    );
  }

  public exportOffers() {
    const offerIds = this.selection.map((x) => x.id);

    this._dialog.open(OfferExportDialogComponent, {
      resolve: () =>
        this._offerService
          .exportMultipleOffersXls(offerIds)
          .pipe(
            mergeMap(async (res) => {
              const blob = await this._offerService
                .downloadXls(res.id)
                .toPromise();
              return {
                fileName: res.fileName,
                blob: blob
              };
            })
          )
          .pipe(
            map((res) => {
              const url = window.URL.createObjectURL(res.blob);

              const link = this._download.nativeElement;
              link.href = url;
              link.download = res.fileName;
              link.click();

              window.URL.revokeObjectURL(url);
            })
          )
    });
  }

  public exportOfferList() {
    const req = {
      createdAtFrom: this.searchData?.createdAtFrom?.format(),
      createdAtTo: this.searchData?.createdAtTo?.format(),
      offerOwnerIds: this.searchData?.offerOwnerIds
    };

    this._dialog.open(OfferExportDialogComponent, {
      resolve: () =>
        this._offerService
          .exportOfferListXls(req)
          .pipe(
            mergeMap(async (res) => {
              const blob = await this._offerService
                .downloadXls(res.id)
                .toPromise();
              return {
                fileName: res.fileName,
                blob: blob
              };
            })
          )
          .pipe(
            map((res) => {
              const url = window.URL.createObjectURL(res.blob);

              const link = this._download.nativeElement;
              link.href = url;
              link.download = res.fileName;
              link.click();

              window.URL.revokeObjectURL(url);
            })
          )
    });
  }

  ngOnDestroy(): void {
    if (this._hubConnection) {
      this._hubConnection.off("offerHasChanged");
    }

    if (this._signalRSubscription) {
      this._signalRSubscription.unsubscribe();
    }
  }
}
